<template>
    <vs-popup class="holamundo validation-modal" :class="{'valid-validation-modal': !invalid}" :title="'Validation'" :active.sync="popupActive">
        <div v-if="Object.values(data).length">
            <div style="margin-bottom: 20px;">
                <h3 style="margin-bottom: 10px;">General</h3>
                <div class="validation-el" v-if="'meta_kg' in data.general">
                    <div class="validation-label">Meta kg:</div> <div :class="{'error': !data.general.meta_kg, 'success': data.general.meta_kg}">{{ data.general.meta_kg ? 'Valid' : 'Invalid' }}</div>
                </div>
                <div class="validation-el">
                    <div class="validation-label">Academic reviewed:</div> <div :class="{'error': !data.general.academic_reviewed, 'success': data.general.academic_reviewed}">{{ data.general.academic_reviewed ? 'Yes' : 'No' }}</div>
                </div>
                <div class="validation-el">
                    <div class="validation-label">Artist reviewed:</div> <div :class="{'error': !data.general.artist_reviewed, 'success': data.general.artist_reviewed}">{{ data.general.artist_reviewed ? 'Yes' : 'No' }}</div>
                </div>
                <div class="validation-el">
                    <div class="validation-label">Thumbnail:</div> <div :class="{'error': !data.general.thumbnail, 'success': data.general.thumbnail}">{{ data.general.thumbnail ? 'Valid' : 'Invalid' }}</div>
                </div>
                <div class="validation-el" v-if="!['image', 'vr_image', 'illustration', 'cg_image'].includes(asset_type)">
                    <div class="validation-label">Thumbnails:</div> <div :class="{'error': !data.general.thumbnails, 'success': data.general.thumbnails}">{{ data.general.thumbnails ? 'Valid' : 'Invalid' }}</div>
                </div>
                <div class="validation-el">
                    <div class="validation-label">Subject:</div> <div :class="{'error': !data.general.subject, 'success': data.general.subject}">{{ data.general.subject ? 'Valid' : 'Invalid' }}</div>
                </div>
                <div class="validation-el">
                    <div class="validation-label">License type:</div> <div :class="{'error': !data.general.license_type, 'success': data.general.license_type}">{{ data.general.license_type ? 'Valid' : 'Invalid' }}</div>
                </div>
            </div>
            <div>
                <h3 style="margin-bottom: 10px;display: flex; align-items: flex-end;" class="validation-variant-header">
                    <i class="star-icon material-icons" v-if="data.general.published_variant"> star </i>
                    <i class="material-icons" v-if="!data.general.published_variant"> star_outline </i>
                    Variation</h3>
                <div v-if="asset_type === '3D'">
                    <div class="validation-label">Type 3D:</div><div>
                    <div class="validation-sub-el">
                        <div class="validation-label">Coobo library link:</div><div :class="{'error': !data.published_variation['3d'].coobo_link, 'success': data.published_variation['3d'].coobo_link}">{{ data.published_variation['3d'].coobo_link ? 'Valid' : 'Invalid' }}</div>
                    </div>
                    <div class="validation-sub-el" v-if="'coobo_validation' in data.published_variation['3d']">
                        <div class="validation-label">Coobo validation:</div><div :class="{'error': !data.published_variation['3d'].coobo_validation, 'success': data.published_variation['3d'].coobo_validation}">{{ data.published_variation['3d'].coobo_validation ? 'Valid' : 'Invalid' }}</div>
                    </div>
                    <div class="validation-sub-el">
                      <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation['3d'].size, 'success': data.published_variation['3d'].size}">{{ data.published_variation['3d'].size ? 'Valid' : data.published_variation['3d'].totalSize ? 'Invalid(>5Mb)' : 'Invalid' }}</div>
                    </div>
                    <div class="validation-sub-el" v-for="(error, index) in data.published_variation['3d'].coobo_validation_errors" :key="index" v-if="data.published_variation['3d'].coobo_validation_errors && data.published_variation['3d'].coobo_validation_errors.length">
                      <div class="validation-label">{{error}}:</div><div :class="{'error': true}">{{ 'Invalid' }}</div>
                    </div>
                    <div class="validation-sub-el" v-for="(warning, index) in data.published_variation['3d'].coobo_validation_warnings" :key="index" v-if="data.published_variation['3d'].coobo_validation_warnings && data.published_variation['3d'].coobo_validation_warnings.length">
                      <div class="validation-label">{{warning}}:</div><div :class="{'warning': true}">{{ 'Warning' }}</div>
                    </div>
                </div>
                </div>
                <div v-if="['image', 'vr_image', 'illustration', 'cg_image'].includes(asset_type)">
                    <div class="validation-label">Type {{asset_type === 'illustration' ? 'Illustration' : asset_type === 'vr_image' ? 'Vr image' : 'Image'}}:</div> <div>
                        <div class="validation-sub-el" >
                            <div class="validation-label">Ready files:</div><div :class="{'error': !data.published_variation.image.ready, 'success': data.published_variation.image.ready}">{{ data.published_variation.image.ready ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                            <div class="validation-label">Extension:</div><div :class="{'error': !data.published_variation.image.extension, 'success': data.published_variation.image.extension}">{{ data.published_variation.image.extension ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                            <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation.image.size, 'success': data.published_variation.image.size}">{{ data.published_variation.image.size ? 'Valid' : 'Invalid' }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="asset_type === 'video' || asset_type === 'animation'">
                    <div class="validation-label">Type Video:</div> <div>
                        <div class="validation-sub-el" >
                            <div class="validation-label">Ready files:</div><div :class="{'error': !data.published_variation.video.ready, 'success': data.published_variation.video.ready}">{{ data.published_variation.video.ready ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                            <div class="validation-label">Extension:</div><div :class="{'error': !data.published_variation.video.extension, 'success': data.published_variation.video.extension}">{{ data.published_variation.video.extension ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                          <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation.video.size, 'success': data.published_variation.video.size}">{{ data.published_variation.video.size ? 'Valid' : 'Invalid' }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="asset_type === 'audio'">
                    <div class="validation-label">Type Audio:</div> <div>
                        <div class="validation-sub-el" >
                            <div class="validation-label">Ready files:</div><div :class="{'error': !data.published_variation.audio.ready, 'success': data.published_variation.audio.ready}">{{ data.published_variation.audio.ready ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                            <div class="validation-label">Extension:</div><div :class="{'error': !data.published_variation.audio.extension, 'success': data.published_variation.audio.extension}">{{ data.published_variation.audio.extension ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                          <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation.audio.size, 'success': data.published_variation.audio.size}">{{ data.published_variation.audio.size ? 'Valid' : 'Invalid' }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="asset_type === 'unity'">
                    <div class="validation-label">Type Unity:</div> <div>
                        <div class="validation-sub-el" >
                            <div class="validation-label">Ready files:</div><div :class="{'error': !data.published_variation.unity.ready, 'success': data.published_variation.unity.ready}">{{ data.published_variation.unity.ready ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                            <div class="validation-label">Extension:</div><div :class="{'error': !data.published_variation.unity.extension, 'success': data.published_variation.unity.extension}">{{ data.published_variation.unity.extension ? 'Valid' : 'Invalid' }}</div>
                        </div>
                        <div class="validation-sub-el">
                          <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation.unity.size, 'success': data.published_variation.unity.size}">{{ data.published_variation.unity.size ? 'Valid' : 'Invalid' }}</div>
                        </div>
                    </div>
                </div>
            </div>
          <div v-if="$store.state.user.role.name === 'Manager' && !invalid">
            <vs-button class="mr-2 shadow-lg" type="gradient" id="validation-save-btn" @click="save" style="margin-top: 10px">
              Save
            </vs-button>
          </div>
          <div v-if="$store.state.user.role.name === 'Media'">
            <vs-button class="mr-2 shadow-lg" type="gradient" @click="closeModal" style="margin-top: 10px">
              Close
            </vs-button>
          </div>
        </div>
    </vs-popup>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default: () => {}
            },
            asset: {
                type: Object,
                default: () => {}
            },
            type: {
                type: String,
                default: 'public'
            },
            asset_type: {
                type: String,
                default: ''
            },
            invalid: {
                type: Boolean,
                default: true
            },
          updateTranslations: Function,
        },
        data () {
            return {
                popupActive: true,
                isAction: false,
            }
        },
        computed: {

        },
        mounted () {
            this.popupActive = true;
        },
        created () {

        },
        watch: {
            popupActive() {
                if (!this.popupActive) {
                    this.closeModal();
                }
            }
        },
        methods: {
            closeModal() {
                setTimeout(() => {
                    this.$emit('closeValidaton', this.isAction);
                }, 1)
            },
          updateAsset() {
            const updateAssetData = (assetData, {onlyUpdateData = 'false'} = {}) => {
              return this.$axios({
                method: id ? 'put' : 'post',
                url: `${url}?onlyUpdateData=${onlyUpdateData}`,
                data: assetData
              })
            }

            let id = this.$route.params.id;
            let url = '/assets';
            if (id) {
              url += '/' + id;
            }
            let data = this.asset;
            let { meta_KG: assetMetakg } = data;
            delete data.meta_KG;

            let promises = [updateAssetData(data)];
            if (assetMetakg && assetMetakg.length) {
              promises.push(updateAssetData({meta_KG: assetMetakg}, {onlyUpdateData: "true"}))
            }
            return Promise.all(promises).catch((error) => {
              this.$root.removeLoading('#validation-save-btn')
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed save asset'})
            })
          },
          save() {
            this.$root.addLoading('#validation-save-btn');

            this.updateAsset().then(() => {
              let url = '/assets/published-validation/' + this.asset._id;

              this.$axios({
                method: 'get',
                url: url
              }).then(res => {
                this.$root.removeLoading('#validation-save-btn');
                this.updateTranslations(res.data)
                this.popupActive = false;
              }).catch((err) => {
                console.log(err);
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                this.$root.removeLoading('#validation-save-btn')
              })
            })
          }
        }
    }
</script>
